import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import Api from "../../../shared/api/api";
import { getStoredOrLatestTestId } from "../helpers/fourHTest";

import "../styles/TestTitle.css";

export default function TestTitle() {
  const { pathname } = useLocation();

  const [title, setTitle] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    let isMounted = true;

    const loadTitle = async () => {
      setError("");

      if (pathname.includes("/coordinator")) {
        setTitle("Coordinator Page");
        return;
      }

      if (pathname.includes("/admin")) {
        setTitle("Admin Page");
        return;
      }

      try {
        const testId =
          await getStoredOrLatestTestId();

        if (!testId) {
          throw new Error(
            "No active test was found."
          );
        }

        const response = await Api.getAll(
          `test/${testId}`
        );

        if (response?.error) {
          throw new Error(response.error);
        }

        if (isMounted) {
          setTitle(
            response?.title ||
              "4-H Knowledge Test"
          );
        }
      } catch (requestError) {
        console.error(
          "Unable to load FourH test title:",
          requestError
        );

        if (isMounted) {
          setTitle("4-H Knowledge Test");
          setError(
            requestError?.message ||
              "The test title could not be loaded."
          );
        }
      }
    };

    loadTitle();

    return () => {
      isMounted = false;
    };
  }, [pathname]);

  return (
    <div className="testTitle">
      <h2 className="title" id="title">
        {title || "Loading..."}
      </h2>

      {error && (
        <span className="sr-only" role="status">
          {error}
        </span>
      )}
    </div>
  );
}